export function keysFirstLetterToLowerCase(obj: any): any {
    if (Array?.isArray(obj)) {
        return obj.map(item => keysFirstLetterToLowerCase(item));
    }
    if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc: any, key: string) => {
            const firstLetterLowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
            acc[firstLetterLowerCaseKey] = keysFirstLetterToLowerCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}

export function getGroupSessionId(data: any): string | null {
    if (!data) {
        return null;
    }
    const raw = data.groupSessionId ?? data.GroupSessionId;
    if (raw == null || raw === '') {
        return null;
    }
    return String(raw);
}

export function getCallDetailIdFromData(data: any): string | number | null {
    if (!data) {
        return null;
    }
    return data.callDetailId ?? data.id ?? data.CallDetailId ?? data.Id ?? null;
}

export function getCallDetailIdFromSession(session: any): string | null {
    const raw = session?._request?.headers?.['X-Calldetailid']?.[0]?.raw;
    if (raw == null || raw === '') {
        return null;
    }
    return String(raw);
}

export function getSipHeaderRaw(session: any, headerName: string): string | null {
    const fromResponse = getSipHeaderRawFromHeaders(session?._response?.headers, headerName);
    if (fromResponse) {
        return fromResponse;
    }
    return getSipHeaderRawFromHeaders(session?._request?.headers, headerName);
}

const FLOW_UUID_HEADER_NAMES = ['X-Flow-Uuid', 'X-flow_uuid', 'X-Flow_uuid'];

export function getSessionFlowUuid(session: any, fallback?: string | null): string | undefined {
    for (const headerName of FLOW_UUID_HEADER_NAMES) {
        const value = getSipHeaderRaw(session, headerName);
        if (value) {
            return value;
        }
    }
    if (fallback) {
        return fallback;
    }
    return undefined;
}

function getSipHeaderRawFromHeaders(headers: any, headerName: string): string | null {
    const header = headers?.[headerName]?.[0];
    if (header == null) {
        return null;
    }
    if (typeof header === 'string') {
        return header;
    }
    const raw = header.raw ?? header.parsed;
    if (raw == null || raw === '') {
        return null;
    }
    return String(raw);
}

export function getCallIdFromSessions(...sessions: Array<any | null | undefined>): string | null {
    for (const session of sessions) {
        const callId = getSipHeaderRaw(session, 'Call-ID');
        if (callId) {
            return callId;
        }
    }
    return null;
}

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isOutgoingSession(session: any): boolean {
    return session?.direction === 'outgoing';
}

export function getCallIdForCallEvent(
    flowUuid: string | null | undefined,
    ...sessions: Array<any | null | undefined>
): string | null {
    const activeSession = sessions.find(Boolean);
    const sipCallId = getCallIdFromSessions(...sessions);

    if (activeSession && isOutgoingSession(activeSession) && flowUuid) {
        return flowUuid;
    }

    if (sipCallId && flowUuid && !UUID_REGEX.test(sipCallId)) {
        return flowUuid;
    }

    return sipCallId ?? flowUuid ?? null;
}
